import { module } from 'angular';
import App from '../../app';
import * as _ from 'lodash';

class GridService {
	
	constructor(utilService, metaService, $timeout) {
		this.utilService = utilService;
		this.metaService = metaService;
		this.$timeout = $timeout;
	}

	setDefaultSetting(gridView){
		gridView.setIndicator({visible: false});
		gridView.setStateBar({visible: false});
		gridView.setPanel({visible: false});
		gridView.setFooter({visible: false});
		gridView.setDisplayOptions({
			fitStyle: 'even',
			rowHeight: 24,
			vscrollBar: false,
			focusVisible: false
		}); 
		// fill로 설정해야 fillWidth가 적용됨
		
		gridView.setSelectOptions({style: 'singleRow'});
		gridView.setEditOptions({editable: false});
		gridView.setEditorOptions({useCssStyle: true, applyCellFont: true});
		gridView.setHeader({height: 30});
		
		gridView.setStyles({
			grid: {
				background: '#fff',
				border: '#eee, 1',
				fontFamily: '"Noto Sans KR", sans-serif',
				fontSize: '12px',
				foreground: '#333',
				selectedBackground: null,
				selectedForeground: null,
				hoveredBackground: '#fff',
				hoveredForeground: '#333'
			},
			header: {
				borderRight: '#fff, 1',
				group: {
					borderRight: '#fff, 1'
				},
				fontFamily: '"맑은 고딕", "Noto Sans KR", sans-serif',
				fontBold: "true",
				foreground: '#000'
			},
			body: {
				line: '#00000000',
				borderRight: '#fff, 1',
				borderBottom: '#eee, 1'
			},
			checkBar: {
				borderBottom: '#eee, 1',
				borderRight: '#fff, 1'
			},
			selection: {
				background: '#1a656565',
				border: '#eee, 1',
				borderBottom: '#fff, 1'
			},
			fixed: {
				borderBottom: '#eee, 1',
				borderRight: '#fff, 1'
			}
		});
	}
	
	getSelectionEditorColumn(config, codes, addEmptyValList){
		config.lookupDisplay = true;
		config.editor = {
				type: 'dropdown',
				domainOnly: true,
				textReadOnly: true,
				dropDownWhenClick: true
		};
		
		config.values = [];
		config.labels = [];
		
		if(addEmptyValList && Array.isArray(addEmptyValList)) {
			addEmptyValList.map((addEmptyVal) => {
				config.values.push(addEmptyVal.value);
				config.labels.push(addEmptyVal.label);
			});
		}
		
		codes.map(code => {
			if(code.cdValNm === ' ') {
				config.values.unshift(code.cdVal);
				config.labels.unshift(code.cdValNm);
			}else{
				config.values.push(code.cdVal);
				config.labels.push(code.cdValNm);
			}
		});
		
		return config;
	}
	
	addRow(grid = {}, provider = {}, generateFunc = () => {}) {
		let newRows = [];
		let gridRows = provider.getJsonRows();
		let selectedRows = gridRows.length === 0 ? [] : grid.getSelectedRows();
		
		if(selectedRows.length == 0) {
			newRows.push(generateFunc());
			gridRows.push(...newRows);
		}else if(selectedRows.length == 1){
			newRows.push(generateFunc());
			gridRows.splice(selectedRows[0] + 1, 0 , ...newRows);
		}else{
			for(let i=0;i<selectedRows.length;i++){
				newRows.push(generateFunc());
			}
			gridRows.splice(selectedRows[selectedRows.length - 1] + 1, 0 , ...newRows); 
		}
		
		provider.setRows(gridRows);
	}
	
	upRow(grid = {}, provider = {}) {
		let gridRows = provider.getJsonRows();
		
		if(gridRows.length === 0) {
			return;
		}
		
		let selectedRows = grid.getSelectedRows();
		let selection = grid.getSelection();
		
		if(selection.startRow === 0) return;
		
		selectedRows.map(index => {
			const target = gridRows.splice(index, 1);
			gridRows.splice(index - 1, 0 , target[0]); 
		});
		
		provider.setRows(gridRows);
		
		selection.startRow = selection.startRow - 1;
		selection.endRow = selection.endRow - 1;
		selection.startItem = selection.startItem - 1;
		selection.endItem = selection.endItem - 1;
		
		grid.setSelection(selection);
	}
	
	downRow(grid = {}, provider = {}) {
		let gridRows = provider.getJsonRows();
		
		if(gridRows.length === 0) {
			return;
		}
		
		let selectedRows = grid.getSelectedRows();
		let selection = grid.getSelection();
		
		if(selection.endRow === gridRows.length - 1) return;
		
		selectedRows.reverse();
		selectedRows.map(index => {
			const target = gridRows.splice(index, 1);
			gridRows.splice(index + 1, 0 , target[0]); 
		});
		
		provider.setRows(gridRows);
		
		selection.startRow = selection.startRow + 1;
		selection.endRow = selection.endRow + 1;
		selection.startItem = selection.startItem + 1;
		selection.endItem = selection.endItem + 1;
		
		grid.setSelection(selection);
	}
	
	onClickRealZabara(that, optionNames, time){
		if(time){
			setTimeout(() => {
				optionNames.map((optionName) => {
					that[optionName] && that[optionName].resetSize();
				});
			}, time);
		}else{
			optionNames.map((optionName) => {
				that[optionName] && that[optionName].resetSize();
			});
		}
	}
	
	convertTreeData(rows = [], parentId, id){
		const utilService = this.utilService;
		let condition;
		let treeData = [];
		
		rows.map(v => {
			utilService.isEmpty(v[parentId]) 
				? treeData.push(v) 
				: this.applyTreeData(treeData, v, condition, parentId, id);
			condition = false;
		});
		
		return {rows : treeData};
	}
	
	applyTreeData(targets = [], record, condition, parentId, id){
		if (condition) return;
		const parentFieldName = record[parentId];
		
		for (let target of targets) {
			const targetId = target[id]; 
			
			if (targetId === parentFieldName) {
				
				if (!target.rows) {
					target.rows = [];
				}
				
				target.rows.push(record);
				condition = true;
				break;
			} else {
				this.applyTreeData(target.rows, record ,condition, parentId, id);
			}
		}
	}
	
	convertArrayData(treeData = [], parentId){
		const target = [];
		treeData.filter(v => !v[parentId])
				.map(node => this.applyArrayData(target, node, parentId));
		return target;
	}
	
	applyArrayData(target, node, parentId){
		let cloneNode = this.utilService.clone(node);
		delete cloneNode.rows;
		delete cloneNode.iconIndex;
		
		target.push(cloneNode);
		
		if(node.rows){
			node.rows.map(child => {
				this.applyArrayData(target, child, parentId);
				child[parentId] = node[parentId];
			});
		}
	}
	
	getGridHeight(pageSize = 5){
		return pageSize * 24 + 33;
	}
	
	getNoField(limit, index, pageNumber = 1){
		return index + 1 + ( pageNumber - 1 ) * limit;
	}
	
	getSelect(pageSize = 5){
		return { pageSize };
	}
	
	getPageInfo(select, pageNumber = 1){
		return {
			pageNumber: pageNumber || 1,
			pageSize: select.pageSize
		};
	}

	getSelectItemsFromCodes(codes, defaultArray = []){
		codes.map(code => {
			defaultArray.push({
				id: code.cdVal,
				text: code.cdValNm
			});
		});
		return defaultArray;
	}
	
	changeBooleanToYN(target){
		let regExp = new RegExp('Yn$');
		
		Object.getOwnPropertyNames(target)
			  .filter(v => regExp.test(v))
			  .map(v => target[v] = target[v] === 'Y' || target[v] === true  ? 'Y' : 'N');
	}
}

module(App.name).service('gridService', GridService);


// WEBPACK FOOTER //
// ./src/app/common/service/grid.service.js